/* eslint-disable */
import React from 'react'
import {message} from 'antd'
import http from '../../Component/Interceptor/Interseptor'
import {Link} from 'react-router-dom'
import MESSANGER from '../BaseComponent/MESSANGER'
import InputMask from 'react-input-mask'
import TMS from '../BaseComponent/TMS'

class CreateSection extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      error: '',
      department: []
    }
  }
  componentDidMount() {
    http.get(`${TMS.TMS_MANAGE_BASE_ORGANIZATION_LIST}`, {}).then((response) => {
      if (response.data.error === null) {
        this.setState({
          department: response.data.object
        })
      } else {
        this.setState({
          department: []
        })
      }
    })
  }

  addTemplate() {
    var title = document.getElementById('title').value
    var departmentId = document.getElementById('departmentId').value
    var titleError = false
    var orgError = false
    var formError = false

    if (title === '') {
      titleError = true
      formError = true
      message.error('عنوان وارد شود')
    } else {
      if (!titleError) {
        this.setState({
          error: ''
        })
      }
    }

    if (departmentId === '') {
      orgError = true
      formError = true
      message.error('دپارتمان وارد شود')
    } else {
      if (!orgError) {
        this.setState({
          error: ''
        })
      }
    }

    if (!formError) {
      let data = {
        title,
        departmentId
      }

      http
        .post(`${TMS.TMS_MANAGE_BASE_SECTION_CREATE}`, data)
        .then((response) => {
          if (response.data.error == null) {
            message.success('بخش جدید اضافه شد')
            setInterval(() => {
              window.location.assign('/base/report/tms/sections')
            }, 2000)
          } else {
          }
        })
        .catch((error) => {
          // alert(JSON.stringify(error))
        })
    }
  }

  submit(e) {
    e.preventDefault()
  }
  render() {
    return (
      <div className={'rtl'}>
        {/*<AdminMenu/>*/}
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>اطلاعات پایه</li>
            <li>مدیریت وظایف</li>
            <li>
              <Link to={'/base/report/tms/sections'}>بخش ها</Link>
            </li>
            <li>افزودن بخش</li>
          </ul>
          <form className="verticalForm" onSubmit={this.submit.bind(this)}>
            <div className="headerVertical">
              <p>افزودن بخش</p>
            </div>
            <div className="formComponent">
              <label>
                دپارتمان <span className="requireFiled">*</span>
              </label>
              <select className="form-control" id="departmentId">
                <option value="">------</option>
                {this.state.department.map((item, index) => (
                  <option value={item.id}>{item.title}</option>
                ))}
              </select>

              <label>
                عنوان <span className="requireFiled">*</span>
              </label>
              <input type="text" id="title" className="form-control" />

              <button className="btn btn-info btn-block" onClick={this.addTemplate.bind(this)}>
                ثبت بخش
              </button>
            </div>
          </form>
        </div>
      </div>
    )
  }
}

export default CreateSection
